{
  "title": "Equipos",
  "subtitle": "Organiza a tus miembros en equipos. Los proyectos se vinculan a un equipo para limitar acceso.",
  "new_team": "Nuevo equipo",
  "name_placeholder": "Nombre del equipo (Marketing, Ingeniería, etc.)",
  "color": "Color:",
  "cancel": "Cancelar",
  "create": "Crear",
  "loading": "Cargando equipos…",
  "empty_title": "Aún no hay equipos",
  "empty_subtitle": "Crea el primero para agrupar miembros y restringir proyectos.",
  "create_first": "Crear el primero",
  "members_one": "{n} miembro",
  "members_other": "{n} miembros",
  "rename": "Renombrar",
  "delete": "Eliminar",
  "favorite_add": "Agregar a favoritos",
  "favorite_remove": "Quitar de favoritos",
  "favorite_error": "No se pudo actualizar el favorito.",
  "no_members_yet": "Sin miembros aún.",
  "view_detail": "Ver detalle",
  "confirm_delete_title": "¿Eliminar el equipo \"{name}\"?",
  "confirm_delete_message": "Los {n} miembros quedarán sin equipo. Los proyectos vinculados quedarán visibles para todo el workspace.",
  "confirm_delete_action": "Eliminar",
  "error_create": "No se pudo crear el equipo.",
  "error_rename": "No se pudo renombrar.",
  "error_delete": "No se pudo eliminar."
}
